<!-- CHAT-939: the Formly button type speaks Kendo. `themeColor` replaces the
     old `btnClass`, so a field config picks a ROLE rather than a CSS class.
     No icon: icons come off text buttons, and the one call site that set
     `iconClass` ("Try It" on channels/edit) no longer does. -->
<button kendoButton
  [themeColor]="props.themeColor"
  [type]="props.type"
  (click)="onClick()">{{ props.label }}</button>
